






import { Vue, Component } from 'vue-property-decorator'

@Component
export default class FlushMessage extends Vue {
  message = ''
  enabled = false

  getMessage() {
    this.message = localStorage.getItem('message') ?? ''
    if (this.message) {
      localStorage.removeItem('message')
    }
    setTimeout(() => {
      this.message = ''
      this.enabled = false
    }, 3000)
  }

  open() {
    this.enabled = true
    this.getMessage()
  }

  mounted() {
    if (localStorage.getItem('message')) {
      this.open()
    }
  }
}
